import { render, staticRenderFns } from "./EditPrintGroupsLoader.vue?vue&type=template&id=6056e694"
import script from "./EditPrintGroupsLoader.vue?vue&type=script&lang=ts"
export * from "./EditPrintGroupsLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports